import { render, staticRenderFns } from "./PasswordInput.vue?vue&type=template&id=45e535c0&scoped=true&"
import script from "./PasswordInput.vue?vue&type=script&lang=js&"
export * from "./PasswordInput.vue?vue&type=script&lang=js&"
import style0 from "./PasswordInput.vue?vue&type=style&index=0&id=45e535c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e535c0",
  null
  
)

export default component.exports